export enum RefDomainType {
  Certification = "CERTIFICATION",
  CommodityCode = "COMMODITY_CODE",
  Clearance = "CLEARANCE",
  Country = "COUNTRY",
  County = "COUNTY",
  City = "CITY",
  Currency = "CURRENCY",
  Degree = "DEGREE",
  DegreeMajor = "DEGREE_MAJOR",
  DegreeMinor = "DEGREE_MINOR",
  ExpenseCategory = "EXPENSE_DEFAULT_CC_CATEGORY",
  Ethnicity = "ETHNICITY",
  LineOfBusiness = "LINE_OF_BUSINESS",
  Month = "MONTH",
  PersonnelActionReason = "PERSONNEL_ACTION_REASON",
  StatusChange = "STATUS_CHANGE",
  VoluntaryTermination = "VOLUNTARY_TERMINATION",
  InvoluntaryTermination = "INVOLUNTARY_TERMINATION",
  PurchaseRequisitionType = "REQUISITION_TYPE",
  Salutation = "NAME_PREFIX",
  ServiceYear = "SERVICE_YEAR",
  State = "STATE",
  UnitOfMeasure = "UNIT_OF_MEASURE",
  VendorStatus = "VENDOR STATUS",
  VeteranStatus = "VETERAN_STATUS",
  Year = "YEAR",
  Iso2Country = "ISO2_COUNTRY"
}
